// Type-only, so this stays a one-way import at runtime — the helpers import the
// copy below as values.
import type { CreditNoteApplicationEligibilityReason } from './applyCreditNote.helpers'

/** Why an invoice can't take a credit application, per eligibility reason. */
export const INELIGIBILITY_REASON_COPY: Record<
  CreditNoteApplicationEligibilityReason,
  string
> = {
  FEATURE_DISABLED: "Credit note applications aren't enabled for this account",
  ACCOUNT_HAS_ERP_INTEGRATION:
    'Unavailable for accounts with an ERP integration',
  INVOICE_HAS_PSP: 'This invoice is collected by a payment provider',
  PAYMENTS_NOT_ON_LEDGER:
    "This invoice's payments aren't recorded on the payments ledger"
}

/** Shown when the API reports an ineligible invoice we have no copy for. */
export const INELIGIBILITY_FALLBACK_COPY =
  "This invoice can't take a credit application"

/** Test id suffix and React key for the fallback message. */
export const UNKNOWN_INELIGIBILITY_KEY = 'unknown'

export const APPLY_CREDITS_SUCCESS_MESSAGE = 'Credits applied'

export const APPLY_CREDITS_ERROR_MESSAGE = 'Failed to apply credits'

export const VERSION_CONFLICT_MESSAGE =
  'The invoice or credit note balance changed. Balances have been refreshed — review and try again.'
